(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/components/other-adress-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/components/other-adress-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const ADRESS_OTHER = svs.ticket_partner.physicalTickets.constants.names.ADRESS_OTHER;
const _svs$ticket_partner$p = svs.ticket_partner.physicalTickets.constants.FORMS.ADRESS_OTHER,
  ADRESS_OTHER_LABEL = _svs$ticket_partner$p.ADRESS_OTHER_LABEL,
  ADRESS_OTHER_MAX = _svs$ticket_partner$p.ADRESS_OTHER_MAX,
  ADRESS_OTHER_MAX_ERROR = _svs$ticket_partner$p.ADRESS_OTHER_MAX_ERROR,
  ADRESS_OTHER_ROWS = _svs$ticket_partner$p.ADRESS_OTHER_ROWS;
const OtherAdressInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state;
  return React.createElement(TextInput, {
    errorMessageMax: ADRESS_OTHER_MAX_ERROR,
    id: ADRESS_OTHER,
    isMultiline: true,
    isRequired: false,
    label: ADRESS_OTHER_LABEL,
    max: ADRESS_OTHER_MAX,
    name: ADRESS_OTHER,
    onChange: handleChange,
    rows: ADRESS_OTHER_ROWS,
    value: state[ADRESS_OTHER]
  });
};
svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.components.OtherAdressInput = OtherAdressInput;

 })(window);